import { z } from 'zod';

/**
 * Strict email regex that requires a valid TLD (2+ chars after the final dot)
 * This catches emails like "bill@done" that pass basic browser validation
 * but fail Stripe and other strict validators
 */
const strictEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const emailSchema = z
  .string()
  .trim()
  .min(1, 'Email is required')
  .max(255, 'Email must be less than 255 characters')
  .email('Please enter a valid email address')
  .refine(
    (email) => strictEmailRegex.test(email),
    'Email must include a valid domain (e.g., example.com)'
  );

export const passwordSchema = z
  .string()
  .min(6, 'Password must be at least 6 characters');

export const fullNameSchema = z
  .string()
  .trim()
  .min(1, 'Name is required')
  .max(100, 'Name must be less than 100 characters');

export const signUpSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  fullName: fullNameSchema,
});

export const signInSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
});

export type SignUpFormData = z.infer<typeof signUpSchema>;
export type SignInFormData = z.infer<typeof signInSchema>;
